import React, { useEffect, useState } from "react";
import "./Crie.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { FormControlLabel, Radio, Tooltip } from "@mui/material";
import phone from "../../../../Assets/phone.svg";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import linkedin from "../../../../Assets/linkedin.svg";
import LinkedINImage from "../../../../Assets/linkedin.svg";
import massageicon from "../../../../Assets/FrameDiff.svg";
import company from "../../../../Assets/people-logo.png";
import education from "../../../../Assets/cap-logo.png";
import experience from "../../../../Assets/jobcompany.png";
import visitLinkImage from "../../../../Assets/visit-link.svg";
import { CloseOutlined } from "@mui/icons-material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import partnerimg from "../../../../Assets/partnerimg.svg";
import joformarimg from "../../../../Assets/joformernew.svg";
import moment from "moment";

const CrieIndirectPathPdf = () => {
  const feedBoxOneData = localStorage.getItem("cip");
  const feedBoxOne = JSON.parse(feedBoxOneData) || [];
  let dataForInformation = feedBoxOne?.dataForInformation;
  let crieData = feedBoxOne?.crieData;
  let joAssociateList = feedBoxOne?.joAssociateList;
  let organizationAssociateList = feedBoxOne?.organizationAssociateList;
  let middleAssociateList = feedBoxOne?.middleAssociateList;
  let strengthList = feedBoxOne?.strengthList;
  let joassociate = feedBoxOne?.joassociate;
  let organizationassociate = feedBoxOne?.organizationassociate;
  let middleassociate = feedBoxOne?.middleassociate;
  let pathWeight = feedBoxOne?.pathWeight;

  const getDaysDifference = (date) => {
    const diff = moment().diff(moment(date), "days");

    if (diff >= 366) {
      return { text: "1 year+", color: "rgb(207 74 74)" };
    } else if (diff >= 181) {
      return { text: "< 1 year", color: "#EC971E" };
    } else if (diff >= 91) {
      return { text: "< 6 months", color: "#C601A2" };
    } else if (diff >= 31) {
      return { text: "< 3 months", color: "#0195C6" };
    } else {
      return { text: "< 1 month", color: "rgb(90 194 157)" };
    }
  };
  const [isPortrait, setIsPortrait] = useState(false);
  useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: portrait)");
    const handleChange = (e) => {
      setIsPortrait(e.matches);
    };
    // set initial value
    setIsPortrait(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  return (
    <div>
      <div className="crie-filter-inner-container crie-cont-2 do_not_print">
        <div className="crie-inner-drop-boxes">
          {/* Jo Associate */}
          <div className="crie_outer_drop">
            <div className="crie-drop-down" style={{ textTransform: "none" }}>
              JO Employee
              <KeyboardArrowDownIcon />
            </div>
          </div>

          <div className="hyphen-conn-main">
            <p className="line-hyphen-conn"></p>
            <p className="hyphen-conn">-</p>
          </div>
          {/* Middle Associate */}
          <div className="crie_outer_drop">
            <div className="crie-drop-down" style={{ textTransform: "none" }}>
              In-Direct Connection
              <KeyboardArrowDownIcon />
            </div>
          </div>

          <div className="hyphen-conn-main">
            <p className="line-hyphen-conn"></p>
            <p className="hyphen-conn">-</p>
          </div>
          {/* organization associate */}
          <div className="crie_outer_drop">
            <div className="crie-drop-down">
              {dataForInformation?.name} Employee
              <KeyboardArrowDownIcon />
            </div>
          </div>
          {/* Path weight */}
          <div className="crie_outer_drop">
            <div className="crie-drop-down">
              Path Strength
              <KeyboardArrowDownIcon />
            </div>
          </div>
        </div>
      </div>
      <div className="crie-filter-inner-container cre-list-cont">
        <div className="crie-inner-drop-boxes-2">
          {joassociate?.length ? (
            <>
              {joassociate?.map((item) => (
                <div className="crie_selected_names">
                  {joAssociateList?.find((i) => i?.joi_id == item)?.name}{" "}
                  <CloseOutlined />
                </div>
              ))}
            </>
          ) : null}
        </div>
        <div className="crie-inner-drop-boxes-2">
          {middleassociate?.length ? (
            <>
              {middleassociate?.map((item) => (
                <div className="crie_selected_names">
                  {middleAssociateList?.find((i) => i?.joi_id == item)?.name}{" "}
                  <CloseOutlined />
                </div>
              ))}
            </>
          ) : null}
        </div>
        <div className="crie-inner-drop-boxes-2">
          {organizationassociate?.length ? (
            <>
              {organizationassociate?.map((item) => (
                <div className="crie_selected_names">
                  {
                    organizationAssociateList?.find((i) => i?.joi_id == item)
                      ?.name
                  }{" "}
                  <CloseOutlined />
                </div>
              ))}
            </>
          ) : null}
        </div>
        <div className="crie-inner-drop-boxes-2">
          {pathWeight?.length ? (
            <>
              {pathWeight?.map((item) => (
                <div className="crie_selected_names">
                  {strengthList?.find((i) => i?.joi_id == item)?.name}{" "}
                  <CloseOutlined />
                </div>
              ))}
            </>
          ) : null}
        </div>
      </div>

      <div style={{ padding: isPortrait ? "0px" : "20px" }}>
        <div className="path-graph-crie">
          <div className="radio-input-crie">
            <FormControlLabel
              className="direct-path-crie"
              checked
              value="indirect"
              control={<Radio />}
              label="Indirect Paths"
            />
          </div>
          {crieData?.length ? (
            <div className="print-div-full">
              {crieData.map((myItem, index) => {
                return myItem.length ? (
                  <>
                    <div
                      className="AllAIOuttercontainer-sidebar_crie"
                      key={index}
                      style={{ pageBreakInside: "avoid" }}
                    >
                      <p className="path_head">Path {index + 1}</p>
                      <div className="AllAi-paths-list">
                        {myItem?.map((item, index) => (
                          <>
                            <div className="siderbar-row">
                              {item?.map((i, idx) => (
                                <div
                                  style={{ display: "flex" }}
                                  className="innerData_ai_cont_crie"
                                >
                                  <div className="first_crie_box_2">
                                    <div className="crie_info">
                                      <div className="crie_name">
                                        {i?.name}
                                        <p className="formerjo-p">
                                          {i.former_jo ? (
                                            <img
                                              src={joformarimg}
                                              alt=""
                                              className="jo-former-icon"
                                            />
                                          ) : (
                                            ""
                                          )}
                                        </p>
                                      </div>
                                      <div>
                                        {i?.primary_organization?.length > 25
                                          ? i?.primary_organization.substr(
                                              0,
                                              25
                                            ) + "..."
                                          : i?.primary_organization}
                                      </div>
                                      <a className="company-profile-mention">
                                        {" "}
                                        <EmailOutlinedIcon
                                          style={{
                                            color: "#003057",
                                            width: "15px",
                                            height: "15px",
                                          }}
                                        />
                                        {i?.email
                                          ? i?.email.split(",")[0]
                                          : "--"}
                                      </a>
                                      <a className="company-profile-mention">
                                        {" "}
                                        <img
                                          src={phone}
                                          alt=""
                                          style={{
                                            width: "13px",
                                            height: "13px",
                                          }}
                                        />
                                        {i?.phone ? i?.phone : "--"}{" "}
                                      </a>
                                      <p className="company-profile-mention-2">
                                        <span>
                                          <img
                                            src={linkedin}
                                            alt=""
                                            style={{
                                              width: "14px",
                                              height: "14px",
                                            }}
                                          />
                                          {i?.linkedin
                                            ? "Linkedin Profile"
                                            : "--"}
                                        </span>
                                        {i?.linkedin ? (
                                          <a
                                            href={i?.linkedin}
                                            className="crie-a-end"
                                            target="_blank"
                                          >
                                            {" "}
                                            <img
                                              src={visitLinkImage}
                                              alt=""
                                              style={{
                                                width: "14px",
                                                height: "14px",
                                              }}
                                            />
                                          </a>
                                        ) : (
                                          <a></a>
                                        )}{" "}
                                      </p>
                                    </div>
                                  </div>
                                  {i?.relation && (
                                    <div className="relation_ai_path_cont_2">
                                      <hr className="horizontal-line-in-aipath" />
                                      <div className="siderbar-image-container relative-crie">
                                        {/* {
                                                                                    i?.last_date ?
                                                                                        <div className='crie-indays'>{getDaysDifference(i?.last_date)}</div> : null
                                                                                } */}
                                        {i?.last_date &&
                                        i?.last_date !== "-" ? (
                                          <div
                                            className="crie-indays"
                                            style={{
                                              background: getDaysDifference(
                                                i?.last_date
                                              ).color,
                                            }}
                                          >
                                            {
                                              getDaysDifference(i?.last_date)
                                                .text
                                            }
                                          </div>
                                        ) : null}
                                        <div className="Siderbar-lits-images">
                                          <Tooltip
                                            title={
                                              "Weighted Connection Strength"
                                            }
                                          >
                                            <div className="weight-between-nodes-crie">
                                              {i?.weight}
                                            </div>
                                          </Tooltip>
                                          <Tooltip title={"Email Exchanged"}>
                                            {i?.relation?.includes("Email") && (
                                              <img
                                                src={massageicon}
                                                alt=""
                                                className="siderbar-modal-img-crie"
                                              />
                                            )}
                                          </Tooltip>
                                          <Tooltip
                                            title={"LinkedIn Connection"}
                                          >
                                            {i?.relation?.includes(
                                              "LinkedIn"
                                            ) && (
                                              <img
                                                src={LinkedINImage}
                                                alt=""
                                                className="siderbar-modal-img-crie"
                                              />
                                            )}
                                          </Tooltip>
                                          <Tooltip
                                            title={"Working in Same Company"}
                                          >
                                            {i?.relation?.includes(
                                              "Organization"
                                            ) && (
                                              <img
                                                src={company}
                                                alt=""
                                                className="siderbar-modal-img-crie"
                                              />
                                            )}
                                          </Tooltip>
                                          <Tooltip
                                            title={"Attended Same College"}
                                          >
                                            {i?.relation?.includes(
                                              "Education"
                                            ) && (
                                              <img
                                                src={education}
                                                alt=""
                                                className="siderbar-modal-img-crie"
                                              />
                                            )}
                                          </Tooltip>
                                          <Tooltip
                                            title={
                                              "Previously Worked in Same Organization"
                                            }
                                          >
                                            {i?.relation?.includes(
                                              "Experience"
                                            ) && (
                                              <img
                                                src={experience}
                                                alt=""
                                                className="siderbar-modal-img-crie"
                                              />
                                            )}
                                          </Tooltip>
                                          <Tooltip title={"Meeting"}>
                                            {i?.relation?.includes(
                                              "Meeting"
                                            ) && (
                                              <CalendarMonthIcon className="siderbar-modal-img-crie" />
                                            )}
                                          </Tooltip>
                                          <Tooltip title={"Regional Partner"}>
                                            {i?.relation?.includes(
                                              "Partner"
                                            ) && (
                                              <img
                                                src={partnerimg}
                                                alt=""
                                                className="siderbar-modal-img"
                                              />
                                            )}
                                          </Tooltip>
                                        </div>
                                      </div>
                                      <div className="connecting-line"></div>
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                            {index < myItem?.length - 1 && (
                              <div className="container-of-joint-line-of-node2-sidebar_crie">
                                <p className="top-line-of-nodes2_crie"></p>
                                <div className="main-for-nodes-line2_crie"></div>
                                <p className="bottom-line-of-nodes2"></p>
                              </div>
                            )}
                          </>
                        ))}
                      </div>
                    </div>
                  </>
                ) : null;
              })}
            </div>
          ) : (
            <div className="crie_path_cont">No Records Found !</div>
          )}
        </div>
      </div>
    </div>
  );
};
export default CrieIndirectPathPdf;
